import React from 'react';
import './Header.scss';

export class Header extends React.Component {
	render() {
		return (
			<div className='Header'>
				<h1>TRAINZ</h1>
			</div>
		);
	}
}
